module.exports = __webpack_public_path__ + "static/media/logo-dark.93453257.svg";